/**
 * Chart colours, from the Skydash palette. Kept here so every chart in the app agrees and a
 * rebrand touches one file.
 *
 * Series order matters for meaning, not just looks: the FIRST colour is the primary indigo and is
 * always the "actual / delivered / received" series; the light blue is the "planned / ordered"
 * comparison. Swapping them would quietly invert how every chart reads.
 */
export const CHART = {
  primary: '#4b49ac',
  light: '#98bdff',
  mid: '#7da0fa',
  violet: '#7978e9',
  alert: '#f3797e',
  grid: '#e6e6f7',
} as const;

/** Categorical ramp for group/location breakdowns. */
export const SERIES = [
  CHART.primary,
  CHART.light,
  CHART.violet,
  CHART.mid,
  CHART.alert,
  '#302f6f',
] as const;
